import { User } from 'src/app/management/model/user';

export class PredefinedMessage {
    id?: number;
    message: string;
    icon: string;
    user?: User;
}
